import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["team"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getTeamIcon, TEAM_ICONS } from 'utils/icons';
import Icon from 'components/Icon';
import { TooltipPill } from 'components/Pill';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function TeamPill(_ref) {
  var _team$teamType;
  var team = _ref.team,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isManagedTeam = (team === null || team === void 0 ? void 0 : team.role) === 'manager';
  return /*#__PURE__*/_jsxs(TooltipPill, _objectSpread(_objectSpread({}, otherProps), {}, {
    title: isManagedTeam ? t('managed_team') : undefined,
    icon: getTeamIcon(team.isSmartTeam),
    iconColor: ((_team$teamType = team.teamType) === null || _team$teamType === void 0 ? void 0 : _team$teamType.colour) || TEAM_ICONS.TEAM,
    children: [team.name, isManagedTeam && /*#__PURE__*/_jsx(Icon, {
      dimmed: true,
      vAlign: true,
      name: "star",
      scale: 0.8,
      ml: "xxxs"
    })]
  }));
}